import { useState } from 'react';

export default function Results() {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const achievements = [
    {
      icon: "ri-trophy-fill",
      number: "150+",
      label: "獲獎作品",
      description: "學生語文競賽獲獎無數"
    },
    {
      icon: "ri-star-fill", 
      number: "95%",
      label: "滿意度",
      description: "家長與學生滿意度"
    },
    {
      icon: "ri-graduation-cap-fill",
      number: "1000+",
      label: "畢業學員",
      description: "成功培育的優秀學員"
    },
    {
      icon: "ri-award-fill",
      number: "15年以上",
      label: "教學經驗",
      description: "全國競賽冠軍教師"
    }
  ];

  const categories = [
    { id: 'all', label: '全部作品' },
    { id: 'elementary', label: '國小作品' },
    { id: 'junior', label: '國中作品' }
  ];

  const testimonials = [
    {
      name: "張媽媽",
      content: "孩子在共學趣學習後，不僅寫作能力大幅提升，還在全國作文比賽中獲得優選！老師的指導真的很專業。",
      student: "家睿媽媽"
    },
    {
      name: "李爸爸",
      content: "從害怕寫作到主動創作，孩子的轉變讓我們很驚喜。感謝老師們的耐心教導和專業指導。",
      student: "彤彤爸爸"
    },
    {
      name: "王媽媽", 
      content: "線上教學的效果超乎預期，孩子不僅學會了寫作技巧，更重要的是培養了對文學的興趣。",
      student: "小雯媽媽"
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-white shadow-sm border-b border-pink-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <h1 className="text-2xl font-bold text-pink-500" style={{fontFamily: '"Pacifico", serif'}}>
                共學趣線上國語文寫作教室
              </h1>
            </div>
            <div className="hidden md:block">
              <div className="ml-10 flex items-baseline space-x-8">
                <a href="/" className="text-gray-700 hover:text-pink-500 px-3 py-2 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer">首頁</a>
                <a href="/courses" className="text-gray-700 hover:text-pink-500 px-3 py-2 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer">課程介紹</a>
                <a href="/teachers" className="text-gray-700 hover:text-pink-500 px-3 py-2 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer">師資團隊</a>
                <a href="/results" className="text-pink-500 font-medium px-3 py-2 rounded-md text-sm whitespace-nowrap cursor-pointer">教學成果</a>
                <a href="/trial" className="text-gray-700 hover:text-pink-500 px-3 py-2 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer">免費試聽</a>
              </div>
            </div>
            <div className="md:hidden">
              <button className="text-gray-700 hover:text-pink-500 w-6 h-6 flex items-center justify-center cursor-pointer">
                <i className="ri-menu-line text-xl"></i>
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-pink-50 to-rose-50 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            教學成果展示
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
            見證學生們的成長軌跡，每一份作品都是努力的結晶，
            每一個獎項都是師生共同努力的成果
          </p>
        </div>
      </section>

      {/* Success Stories */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              成功案例分享
            </h2>
            <p className="text-xl text-gray-600">
              每個孩子都有自己的成長故事
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="bg-pink-50 border-2 border-pink-200 rounded-2xl p-6 mb-8 inline-block">
                <div className="text-center">
                  <p className="text-2xl font-bold text-pink-500">長期學習</p>
                  <p className="text-gray-700 font-medium">從抗拒到年年得獎</p>
                </div>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6">從害怕到熱愛的轉變</h3>
              <div className="space-y-6">
                <div className="flex gap-4">
                  <div className="w-8 h-8 bg-pink-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <span className="text-white font-bold text-sm">1</span>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">初期評估</h4>
                    <p className="text-gray-600">小碩剛來時對寫作非常抗拒，常常面對空白紙張不知道如何下筆。</p>
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="w-8 h-8 bg-pink-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <span className="text-white font-bold text-sm">2</span>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">個人化指導</h4>
                    <p className="text-gray-600">老師針對他的弱點設計,以鼓勵及耐心支持肯定引導寫作。</p>
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="w-8 h-8 bg-pink-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <span className="text-white font-bold text-sm">3</span>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">逐步進步</h4>
                    <p className="text-gray-600">經過長期的學習,小碩培養出穩定的寫作力,還年年得獎。</p>
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="w-8 h-8 bg-pink-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <span className="text-white font-bold text-sm">4</span>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">一生受用</h4>
                    <p className="text-gray-600">培養出自信心及一生受用的寫作能力跟表達力。</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="relative">
              <img 
                src="https://static.readdy.ai/image/6a4168e1db81f7a7fb40133af0c991e9/1f293d18e6a0167aa58f364f5cd9fa33.jpeg"
                alt="成功案例"
                className="w-full rounded-2xl shadow-2xl object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Achievements Stats */}
      <section className="py-20 bg-pink-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            {achievements.map((achievement, index) => (
              <div key={index} className="text-center">
                <div className="w-20 h-20 bg-pink-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className={`${achievement.icon} text-3xl text-pink-500`}></i>
                </div>
                <div className="text-4xl font-bold text-gray-900 mb-2">{achievement.number}</div>
                <div className="text-xl font-semibold text-pink-500 mb-2">{achievement.label}</div>
                <p className="text-gray-600">{achievement.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Teacher Qualifications */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              師資標準
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              我們對教師有嚴格的篩選標準，確保每位老師都能提供最專業的教學服務
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-pink-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-graduation-cap-fill text-3xl text-pink-500"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">學歷要求</h3>
              <p className="text-gray-600 leading-relaxed">
                正統師範及教育大學語文系畢業，具備卓越的國語教學能力
              </p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-pink-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-time-fill text-3xl text-pink-500"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">經驗要求</h3>
              <p className="text-gray-600 leading-relaxed">
                15年以上教學經驗，熟悉各年齡層學生的學習特點
              </p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-pink-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-heart-fill text-3xl text-pink-500"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">教師證</h3>
              <p className="text-gray-600 leading-relaxed">
                對教育充滿熱忱，能夠耐心引導學生，激發學習興趣
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Parent Testimonials */}
      <section className="py-20 bg-pink-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              家長見證分享
            </h2>
            <p className="text-xl text-gray-600">
              聽聽家長們對孩子學習成果的真實回饋
            </p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="bg-white rounded-2xl p-8 shadow-lg">
                <div className="text-center mb-6">
                  <div className="w-16 h-16 bg-pink-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-double-quotes-l text-2xl text-pink-500"></i>
                  </div>
                </div>
                <p className="text-gray-700 leading-relaxed mb-6 italic">
                  "{testimonial.content}"
                </p>
                <div className="text-center">
                  <h4 className="font-bold text-gray-900">{testimonial.name}</h4>
                  <p className="text-pink-500">{testimonial.student}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Student Works */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              學生優秀作品
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              引導學生寫出心智圖，再按照大綱段落完成以下作品
            </p>
          </div>

          <div className="flex justify-center">
            <img 
              src="https://static.readdy.ai/image/6a4168e1db81f7a7fb40133af0c991e9/919a653535b0a5324c7217035f057756.jpeg"
              alt="學生優秀作品"
              className="w-full max-w-4xl rounded-2xl shadow-2xl object-cover"
            />
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-pink-500 to-rose-500">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6">
            讓您的孩子也成為下一個成功案例
          </h2>
          <p className="text-xl text-pink-100 mb-8 max-w-2xl mx-auto">
            立即加入我們，讓專業的教師團隊幫助您的孩子發掘寫作潛能，創造屬於他們的成功故事
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="bg-white text-pink-500 px-8 py-4 rounded-full font-semibold hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer">
              立即免費試聽
            </button>
            <a href="/admin" className="border-2 border-white text-white px-8 py-4 rounded-full font-semibold hover:bg-white hover:text-pink-500 transition-colors whitespace-nowrap cursor-pointer">
              管理作品內容
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div className="md:col-span-2">
              <h3 className="text-2xl font-bold mb-4 text-pink-400" style={{fontFamily: '"Pacifico", serif'}}>
                共學趣線上國語文寫作教室
              </h3>
              <p className="text-gray-400 mb-6 leading-relaxed">
                專業線上寫作教室，致力於培養孩子的寫作能力與創意思維。
                我們相信每個孩子都有無限潛能，只需要正確的引導。
              </p>
              <div className="flex gap-4">
                <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-pink-500 transition-colors cursor-pointer">
                  <i className="ri-line-fill text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover-bg-pink-500 transition-colors cursor-pointer">
                  <i className="ri-facebook-fill text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-pink-500 transition-colors cursor-pointer">
                  <i className="ri-instagram-fill text-lg"></i>
                </a>
              </div>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">快速連結</h4>
              <ul className="space-y-2">
                <li><a href="/courses" className="text-gray-400 hover:text-white transition-colors cursor-pointer">課程介紹</a></li>
                <li><a href="/teachers" className="text-gray-400 hover:text-white transition-colors cursor-pointer">師資團隊</a></li>
                <li><a href="/results" className="text-gray-400 hover:text-white transition-colors cursor-pointer">教學成果</a></li>
                <li><a href="/trial" className="text-gray-400 hover:text-white transition-colors cursor-pointer">免費試聽</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">聯絡資訊</h4>
              <ul className="space-y-2 text-gray-400">
                <li className="flex items-center gap-2">
                  <i className="ri-line-fill"></i>
                  <span>@write123</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-time-fill"></i>
                  <span>週一至週日 9:00-21:00</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-global-fill"></i>
                  <span>線上教學，不限地區</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2025 共學趣線上寫作教室. All rights reserved. | 
              <a href="https://readdy.ai/?origin=logo" className="hover:text-white transition-colors cursor-pointer ml-2">Powered by Readdy</a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
